import { baseApi } from "@/data/restApi/baseApi";
import { ListResponse } from "@/common/baseTypes";
import {
  unwrapResponseData,
  convertErrorToUserMessage
} from "@/data/restApi/resUtils";
import { ParkingRepository } from "../parkingRepository";
import {
  ParkingCounter,
  ParkingSetInsideRequest,
  ParkingSetTotalRequest
} from "@/common/parkingTypes";

class ParkingRestRepository implements ParkingRepository {
  getStats(): Promise<ParkingCounter[]> {
    return baseApi
      .get<ListResponse<ParkingCounter>>("/parking/stats")
      .then(res => {
        return res.data.items;
      });
  }

  updateInsideCount(id: number, inside: number): Promise<void> {
    return baseApi
      .post(`/parking/${id}/inside`, <ParkingSetInsideRequest>{
        inside
      })
      .then(unwrapResponseData)
      .catch(err => {
        throw convertErrorToUserMessage(err);
      });
  }

  updateTotalCount(id: number, total: number): Promise<void> {
    return baseApi
      .post(`/parking/${id}/total`, <ParkingSetTotalRequest>{
        total
      })
      .then(unwrapResponseData)
      .catch(err => {
        throw convertErrorToUserMessage(err);
      });
  }
}

export default new ParkingRestRepository();
